import {
  Reducer,
  ReducerActions,
  VehicleSearchState,
  VehicleSearchStateAction,
  vehicleSearchActions,
} from '@/context/types';

const reducerActions: ReducerActions<VehicleSearchState, VehicleSearchStateAction> = (state, payload) => ({
  vehicle_search_update_data: () => ({ ...state, data: payload }),
});

export const vehicleSearchReducer: Reducer<VehicleSearchState, VehicleSearchStateAction> = (
  state,
  { action, payload },
) => (vehicleSearchActions.includes(action) ? reducerActions(state, payload)[action]() : { ...state });

vehicleSearchReducer.key = 'vehicleSearch';
vehicleSearchReducer.initialState = { data: [] };
